import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AuthResponse  {
    _originalTypeClassName = "MidApp.BO.AuthResponse";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AuthResponse.translate = translateService;
}
this.token = null;
this.username = null;
this.expiresIn = null;
this.firstName = null;
this.isManager = false;
this.isAdmin = false;
this.themeName = null;
this.avatarName = null;
this.genderString = null;
this.language = null;
this.DisableUser = false;
this.UserLanguage = null;
this.Company = null;
this.KnowledgeBase = null;
this.AuthResponseKey = null;
this._key = this.AuthResponseKey = 0; 
}

static translate: TranslateService;
_key: any;
token:any;
username:any;
expiresIn:any;
firstName:any;
isManager:any;
isAdmin:any;
themeName:any;
avatarName:any;
genderString:any;
language:any;
DisableUser:any;
UserLanguage:any;
Company:any;
KnowledgeBase:any;
private _AuthResponseKey:any;
get AuthResponseKey(): any {
    return this._AuthResponseKey;
  }
set AuthResponseKey(value: any) {
    this._AuthResponseKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AuthResponseKey == null || $this.AuthResponseKey == 0;
            }


}